"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Modules
const react_1 = require("react");
// Icons
const KeyboardBackspace_1 = __importDefault(require("@material-ui/icons/KeyboardBackspace"));
// Styled
const Styled = __importStar(require("./Styled"));
function CarouselArrows(props) {
    const testId = `${props.testId}-CarouselArrows`;
    const [disableBack, setDisableBack] = (0, react_1.useState)(true);
    const [disableFoward, setDisableFoward] = (0, react_1.useState)(false);
    const handleClickBack = () => {
        let newElementSize = props.elementSize;
        if (props.carouselRef.scrollLeft - newElementSize < 0) {
            newElementSize = props.carouselRef.scrollLeft;
            setDisableBack(true);
        }
        setDisableFoward(false);
        props.setNewScrollPosition(props.carouselRef.scrollLeft - newElementSize);
    };
    const handleClickFoward = () => {
        var _a;
        let newElementSize = props.elementSize;
        if (props.carouselRef.scrollLeft + newElementSize + ((_a = props.carouselRef) === null || _a === void 0 ? void 0 : _a.offsetWidth) >
            props.carouselRef.scrollWidth) {
            newElementSize = props.carouselRef.scrollWidth - props.carouselRef.scrollLeft;
            setDisableFoward(true);
        }
        setDisableBack(false);
        props.setNewScrollPosition(props.carouselRef.scrollLeft + newElementSize);
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.Wrapper, Object.assign({ "data-testid": testId, className: testId }, { children: [(0, jsx_runtime_1.jsx)(Styled.ArrowWrapper, Object.assign({ "data-testid": `${testId}-back`, onClick: handleClickBack, disabled: disableBack, lightMode: props.lightMode }, { children: (0, jsx_runtime_1.jsx)(KeyboardBackspace_1.default, {}) })), (0, jsx_runtime_1.jsx)(Styled.ArrowWrapper, Object.assign({ "data-testid": `${testId}-foward`, onClick: handleClickFoward, disabled: disableFoward, lightMode: props.lightMode, foward: true }, { children: (0, jsx_runtime_1.jsx)(KeyboardBackspace_1.default, {}) }))] })));
}
exports.default = CarouselArrows;
